<template>
  <div class="simple-container">
    <div :class="bgSimple" ref="bgSimple" id="SimpleView">
       <div class="front-wall no-select" :style="{width: frontWallWidthRem + 'rem'}" ref="frontWall">
         <div class="pj1_container" ref="pjBox">
          <div v-if="isLShaped" :class="position === 3 ? 'pj1_container_lx' : 'pj1_container_lx_down'" :style="{'background': `url(${pjImgSrc}) no-repeat 50% ${backImgTransTop} / ${backImgSize}`}"></div>
          <img v-if="!isLShaped" src="@/assets/parts/simple/img_P.png" class="pj1_container_img">
          <div ref="vArrow" class="v-arrow arrowImg" :class="{pressArrowImg:vDragFlag}"
            @touchstart="onVTouchStart" @touchmove.prevent="onVTouchMove" @touchend="onVTouchEnd">
          </div>
        </div>
          <div class="project-bottom-to-floor-arrow">
            <ArrowItem :itemWidth='distanceFloorToBottom' color='#ed843d' isVertical=true isBottomFix=true></ArrowItem>
            <label class="lineitem to_bottom_left" :style="{'top':arrowtextToBottom + 'rem'}">(1)</label>
          </div>
         <div class="screen" :style="{height:screenStatusHeight + 'rem', width: screenWidth / 100 * 2.67 + 'rem',top:screenStatusTop / 100 * 2.67 +'rem'}">
         <div class="project-top-w-arrow" v-if="position !== 1">
            <ProjectArrowItem color= '#ff3399' :PjItemWidth='PjscreenWidth'></ProjectArrowItem>
            <label class="lineitem to_bottom_top" :style="{'left':arrowtextToTop + 'rem'}">(5)</label>
          </div>
          <div class="project-top-v-arrow-r" v-if="position !== 1">
            <ProjectArrowItem :PjItemWidth='screenStatusHeight * 100 / 2.67' color= '#ff3399' isVertical=true></ProjectArrowItem>
              <label class="lineitem to_bottom_bottom_celing" :style="{'bottom':0 - arrowtextToTopCeling + 'rem'}">(5)</label>
          </div>
          <div class="screen-bg">
            <div class="screenHeightBg" :style="{height:InitScreenHeight / 100 * 2.67 + 'rem', width: screenWidth / 100 * 2.67 + 'rem'}" v-if="screenStatus.top < 0"></div>
            <div class="over_screen_status_top" :style="{'left': overScreenLeft + 'rem'}">
            <ArrowItem :itemWidth='0-screenStatus.top' color='#6666ff' isVertical=true v-if="screenStatus.top < 0"></ArrowItem>
            </div>
            <img src="@/assets/parts/simple/screen.png" class="screenImg" :style="{height:screenStatusHeight + 'rem', width: screenWidth / 100 * 2.67 + 'rem'}">
            <label class="lineitem screen_center" :style="{'top':arrowtextScreenT + 'rem','left':arrowtextScreenL + 'rem'}">(4)</label>
            <div class="screenHeightBgBottom" :style="{height:InitScreenHeight / 100 * 2.67 + 'rem', width: screenWidth / 100 * 2.67 + 'rem'}" v-if="floorB < 0"></div>
            <div class="over_screen_status_bottom" :style="{'left' : overScreenLeft + 'rem'}" v-if="floorB < 0">
              <ArrowItem :itemWidth='0-floorToBottom' color='#ffff00' isVertical=true isBottomFix=true></ArrowItem>
            </div>
          </div>
          <div class="project-top-v-arrow-l" v-if="position === 1">
            <ProjectArrowItem :PjItemWidth='screenStatusHeight * 100 / 2.67' color= '#ff3399' isVertical=true LisVertical=true></ProjectArrowItem>
            <label class="lineitem to_bottom_top_celing" :style="{'top':arrowtextToTopCeling + 'rem'}">(5)</label>
          </div>
          <div class="project-bottom-w-arrow" v-if="position === 1">
            <ProjectArrowItem color= '#ff3399' :PjItemWidth='PjscreenWidth'></ProjectArrowItem>
            <label class="lineitem to_bottom_top" :style="{'left':arrowtextToTop + 'rem'}">(5)</label>
          </div>
        </div>
        <div class="screen-top-to-ceiling-arrow">
          <ArrowItem :itemWidth='Math.abs(screenStatus.top)' color='#6666ff' isVertical=true v-if="screenStatus.top > 0"></ArrowItem>
          <label class="lineitem to_bottom_left" :style="{'top':arrowtextScreenStatusTop + 'rem'}">(3)</label>
        </div>
        <div class="screen-bottom-to-floor-arrow">
          <ArrowItem :itemWidth='Math.abs(floorToBottom)' color='#ffff00' isVertical=true isBottomFix=true v-if="floorB > 0"></ArrowItem>
          <label class="lineitem to_bottom_left" :style="{'top':arrowtextFloorToBottom + 'rem'}">(2)</label>
        </div>
        <div :class="this.isLShaped ? 'touying-lx' : 'touying'" :style="[{transform:`scale(${YingScreenSize})`}, {'opacity': YingOpacity}]"></div>
        <img src="@/assets/parts/simple/people.png" class="man" :style="{height: manImgHeight + 'px'}" v-if="selectedModelData.category !== 5" />
       </div>
       <!-- <div class="throw-distance-arrow">
         <img src="@/assets/parts/simple/line_throw distance.png">
       </div> -->

    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ArrowItem from './SimpleArrow'
import ProjectArrowItem from './simpleProjectArrow'
export default {
  name: 'SimpleView',
  data () {
    return {
      frontWallWidth: 200,
      vDragFlag: false,
      displayCeilingH: 400,
      draggableHeight: 150,
      ceilingHFixed: 135,
      screenStatus: { height: 0, top: 0 },
      isIpad: false,
      screnTop: 25,
      lineLeftWidth: 4,
      mamHeight: 180,
      lx04UpImgSrc: require('@/assets/parts/simple/simpleui_projector_lx_up.png'),
      lx04DownimgSrc: require('@/assets/parts/simple/simpleui_projector_lx_down.png')
    }
  },

  components: {
    ArrowItem,
    ProjectArrowItem
  },

  computed: {
    ...mapState(['cateRadio', 'houseInfo', 'graph', 'drawData', 'position', 'floor2bottom', 'selectedModelData',
      'selectedLensData' ]),
    isLShaped () {
      return this.$commonViewJs.isLShaped()
    },
    pjImgSrc () {
      if (this.position === 3) {
        return this.lx04UpImgSrc
      } else {
        return this.lx04DownimgSrc
      }
    },
    position034 () {
      return this.position === 0 || this.position === 3 || this.position === 4
    },
    bgSimple () {
      if (this.selectedModelData.category === 5) {
        return 'htm-simple'
      } else {
        if (this.houseInfo.roomH < 400) {
          return 'bm-simple-h2'
        } else if (this.houseInfo.roomH >= 400 && this.houseInfo.roomH < 900) {
          return 'bm-simple-h4'
        } else {
          return 'bm-simple-h9'
        }
      }
    },
    frontWallWidthRem () {
      return this.frontWallWidth / 100 * 2.67
    },
    pjZMin () {
      return 0
    },
    pjZMax () {
      return this.houseInfo.roomH
    },
    screenStatusHeight () {
      return this.screenStatus.height
    },
    screenWidth () {
      let width = this.graph.scrnW * this.ceilingHFixed / this.houseInfo.roomH
      return width >= this.frontWallWidth ? this.frontWallWidth : width
    },
    screenStatusTop () {
      if (this.screenStatus.top < 0) {
        if (this.position034) {
          return this.screenStatus.top - this.screnTop
        } else {
          return this.screenStatus.top
        }
      } else {
        if (this.position034) {
          return this.screenStatus.top - this.screnTop
        } else {
          return this.screenStatus.top
        }
      }
    },
    floorToBottom () {
      return this.floor2bottom * this.ceilingHFixed / this.houseInfo.roomH
    },
    floorB () {
      return this.floor2bottom
    },
    distanceFloorToBottom () {
      if (this.$commonViewJs.isLShaped()) {
        return this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH - (this.position === 3 ? 22 : 18)
      } else if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
        return this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH + 14
      } else {
        // if (this.houseInfo.roomH < 400) {
        //   console.log(this.floor2footProjector * (this.frontWallWidth - this.frontWallHeight) / this.houseInfo.roomH)
        //   return this.floor2footProjector * (this.frontWallWidth - this.frontWallHeight) / this.houseInfo.roomH + 8
        // } else {
        return this.floor2footProjector * this.ceilingHFixed / this.houseInfo.roomH
        // }
      }
    },
    floor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2foot = f2l - BrightnessDataFe
        return f2foot > 0 ? f2foot : 0
      } else {
        let f2foot = f2l - this.selectedLensData.fe
        return f2foot > 0 ? f2foot : 0
      }
    },
    getBrightnessFe () {
      let brightnessfe
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessfe = this.Brightness.optionLens[i].fe / 10
          }
        }
      }
      return brightnessfe
    },
    PjscreenWidth () {
      return this.screenWidth - this.lineLeftWidth
    },
    InitScreenHeight () {
      let newPoinet = this.drawData[0]
      if (this.screenStatus.top < 0) {
        return Math.abs(newPoinet[0].z) * this.ceilingHFixed / this.houseInfo.roomH
      } else {
        return (newPoinet[3].z - this.houseInfo.roomH) * this.ceilingHFixed / this.houseInfo.roomH
      }
    },
    overScreenLeft () {
      return (this.screenWidth / 2) / 100 * 2.67
    },
    YingScreenSize () {
      let SimplePjTops = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      let MaxRoomCeilingHeight = 135
      let MinRoomCeilingHeight = 0
      let MaxScale = 1.5
      let MinScale = 1
      let bili = (MaxRoomCeilingHeight - MinRoomCeilingHeight) / (MaxScale - MinScale) / 10
      return MinScale + (MaxRoomCeilingHeight - SimplePjTops) * 0.1 / bili
    },
    YingOpacity () {
      let SimplePjTops = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      let MaxRoomCeilingHeight = 135
      let MinRoomCeilingHeight = 0
      let MaxScale = 0
      let MinScale = 0.8
      let bili = (MaxRoomCeilingHeight - MinRoomCeilingHeight) / (MaxScale - MinScale) / 10
      return MinScale + (MaxRoomCeilingHeight - SimplePjTops) * 0.1 / bili
    },
    arrowtextToBottom () {
      return 0 - (this.distanceFloorToBottom - 14) / 100 * 2.67 / 2
    },
    arrowtextFloorToBottom () {
      return 0 - (this.floorToBottom - 14) / 100 * 2.67 / 2
    },
    arrowtextScreenStatusTop () {
      return (this.screenStatus.top - 14) / 100 * 2.67 / 2
    },
    arrowtextScreenT () {
      return this.screenStatusHeight / 2
    },
    arrowtextScreenL () {
      return this.screenWidth / 100 * 2.67 / 2
    },
    arrowtextToTop () {
      return this.PjscreenWidth / 100 * 2.67 / 2
    },
    arrowtextToTopCeling () {
      return this.screenStatusHeight / 2
    },
    manImgHeight () {
      let height = (this.ceilingHFixed * this.mamHeight) / this.houseInfo.roomH
      return height > this.ceilingHFixed ? this.ceilingHFixed : height
    },
    backImgTransTop () {
      let top = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
      let n = Math.floor(top / (this.ceilingHFixed / 20))
      if (this.position === 3) {
        return `${(-45.5 * n - 29) / 100 * 2.67}rem`
      } else if (this.position === 4) {
        return `${(-45.6 * n - 2) / 100 * 2.67}rem`
      } else {
        return `${(-38 * n + 1) / 100 * 2.67}rem`
      }
    },
    backImgSize () {
      if (this.position === 3 || this.position === 4) {
        return `${150 / 100 * 2.67}rem`
      } else {
        return `${90 / 100 * 2.67}rem`
      }
    }
  },

  watch: {
    drawData: {
      handler (val, oldVal) {
        if (val) {
          // let value = this.isIpad ? 200 : 60
          let screenPArr = val[0]
          let screenH = screenPArr[3].z - screenPArr[0].z
          let height = (this.ceilingHFixed * screenH) / this.houseInfo.roomH / 100 * 2.67
          // let top = ((screenPArr[0].z - this.houseInfo.roomH + 200) * this.ceilingHFixed) / this.houseInfo.roomH + value
          let top = (screenPArr[0].z * this.ceilingHFixed) / this.houseInfo.roomH > this.ceilingHFixed ? this.ceilingHFixed : (screenPArr[0].z * this.ceilingHFixed) / this.houseInfo.roomH
          this.screenStatus = { height, top }
          this.setPosition()
        }
      },
      immediate: true
    }
  },

  mounted () {
    this.setPosition()
  },

  methods: {
    ...mapMutations(['PJZ', 'SET_POSITION', 'SET_OTHER_POSITION']),
    onVTouchStart (e) {
      let ev = e.targetTouches[0]
      this.vDragFlag = true
      this.oldY = ev.clientY
      this.pjBoxTop = this.$refs['pjBox'].offsetTop
    },
    onVTouchMove (e) {
      if (this.vDragFlag) {
        let touch = e.targetTouches[0]
        let newY = touch.clientY
        let moveY = newY - this.oldY
        let pjTop = this.pjBoxTop + moveY
        if (pjTop <= 0) {
          pjTop = 0
        } else if (pjTop >= this.ceilingHFixed) {
          pjTop = this.ceilingHFixed
        }
        // this.$refs['pjBox'].style.top = pjTop + 'px'
        // let pjzVal = this.houseInfo.roomH - 200 + (pjTop * this.draggableHeight / this.displayCeilingH)
        let pjzVal = pjTop * this.houseInfo.roomH / this.ceilingHFixed
        this.PJZ(pjzVal)
      }
    },
    onVTouchEnd () {
      this.vDragFlag = false
    },
    setPosition () {
      this.$nextTick(() => {
        const pjTop = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH / 100 * 2.67
        let pjTopPx = this.graph.pjZ * this.ceilingHFixed / this.houseInfo.roomH
        this.$refs['pjBox'].style.top = pjTop + 'rem'
        if (this.position === 3 || this.position === 4) return
        if (pjTopPx === 0) {
          this.SET_POSITION(1)
          this.SET_OTHER_POSITION(1)
        } else if (pjTopPx === this.ceilingHFixed) {
          this.SET_POSITION(0)
          this.SET_OTHER_POSITION(0)
        }
      })
    }
  }
}

</script>
<style scoped>

.bm-simple-h2 {
  background: url("../../assets/parts/simple/bg_business_h2.png") no-repeat;
  background-size: cover;
  height: 320px;
  position: relative;
  overflow: hidden;
}

.bm-simple-h4 {
  background: url("../../assets/parts/simple/bg_business_h4.png") no-repeat;
  background-size: cover;
  height: 320px;
  position: relative;
  overflow: hidden;
}

.bm-simple-h9 {
  background: url("../../assets/parts/simple/bg_business_h9.png") no-repeat;
  background-size: cover;
  height: 320px;
  position: relative;
  overflow: hidden;
}

.htm-simple {
  background: url("../../assets/parts/simple/bg_home.png") no-repeat;
  background-size: cover;
  height: 320px;
  position: relative;
  overflow: hidden;
}

.front-wall {
  position: absolute;
  height: 135px;
  top: 85px;
  left: 65px;
}

.pj1_container {
  position: absolute;
  right: 20px;
  z-index: 333;
  display: flex;
}

.pj1_container_img {
  width: 60px;
}

.pj1_container_lx {
  position: absolute;
  z-index: 555;
  height: 46px;
  right: -21px;
  overflow: hidden;
  transform: rotateX(0deg) rotateY(-195deg) translateX(0%);
  -moz-transform: rotateX(0deg) rotateY(-195deg) translateX(0%);
  transform-style:preserve-3d;
  -moz-transform-style:preserve-3d;
  background-size: 90px;
  width: 90px;
}

.pj1_container_lx_down {
  position: absolute;
  z-index: 555;
  height: 46px;
  right: -36px;
  overflow: hidden;
  transform: rotateX(0deg) rotateY(0deg) translateX(0%);
  -moz-transform: rotateX(0deg) rotateY(0deg) translateX(0%);
  transform-style:preserve-3d;
  -moz-transform-style:preserve-3d;
  background-size: 90px;
  width: 90px;
}

.arrowImg {
  width: 25px;
  height: 70px;
  background: url("../../assets/parts/simple/btn_move.png") no-repeat;
  background-size: contain;
}

.pressArrowImg {
  background: url("../../assets/parts/simple/btn_move_hover.png") no-repeat;
  background-size: contain;
}

.v-arrow {
  position: absolute;
  left: 80px;
  top: 0;
}

.screen {
  position: absolute;
  left: 100px;
  transform: translateX(-50%);
}

.screen-top-to-ceiling-arrow {
  position: absolute;
  left: 100px;
  top: 8px;
}

.screen-bottom-to-floor-arrow {
  position: absolute;
  left: 100px;
  bottom: 5px;
}

.project-bottom-to-floor-arrow {
  position: absolute;
  bottom: -10px;
  left: 160px;
  z-index: 333;
}

.project-top-v-arrow-r {
  position: absolute;
  top: 0;
  right: -26px;
}

.project-top-v-arrow-l {
  position: absolute;
  top: 0;
  left: 0;
}

.project-bottom-w-arrow {
  position: absolute;
  bottom: -26px;
  left: 0;
}

.screen-bg {
  position: relative;
}

.screenHeightBg {
  background: rgba(183, 183, 183, 0.5);
  position: absolute;
  left: 0px;
  z-index: 222;
}

.over_screen_status_top {
  position: absolute;
  top: 7px;
  z-index: 222;
}

.screenHeightBgBottom {
  background: rgba(183, 183, 183, 0.5);
  position: absolute;
  left: 0px;
  bottom: 4px;
  z-index: 222;
}

.over_screen_status_bottom {
  position: absolute;
  bottom: 10px;
  z-index: 222;
}

.touying {
  background: url("../../assets/parts/simple/img_P_projection.png") no-repeat;
  background-size: contain;
  position: absolute;
  top: 135px;
  left: 120px;
  width: 65px;
  height: 25px;
}

.touying-lx {
  background: url("../../assets/parts/simple/img_P_projection.png") no-repeat;
  background-size: contain;
  position: absolute;
  top: 150px;
  left: 140px;
  width: 50px;
  height: 14px;
}

.lineitem {
  font-size: 10px;
  position: absolute;
}

.to_bottom_left {
  left: 5px;
}

.to_bottom_top {
  top: 0;
}

.to_bottom_top_celing {
  left: -30px;
}

.to_bottom_bottom_celing {
  right: -2px;
}

.man {
  position: absolute;
  left: 10px;
  bottom: 0;
}
</style>
